import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/config.service';
import config from 'devextreme/core/config';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
// Generated per-machine by `devextreme-license` (runs via the npm pre-hooks)
// from the DevExpress licence in %APPDATA%\DevExpress\DevExpress_License.txt.
// Gitignored — DevExtreme 26.1+ no longer accepts portal keys directly.
import { licenseKey } from './.devextreme/license-key';

if (environment.production) {
  enableProdMode();
}
config({licenseKey});
bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
